import { Component, Input, OnDestroy, ViewEncapsulation, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { AppConstants } from '../../app.constants';

import { LicenseService } from '../../core/services/http-services/license.service';
import { LicenseStatusModel } from '../../core/models/view-models/license-models/license-status.model';
import { IsInRolePipe } from '../../shared-module/pipes/is-in-role.pipe';

@Component({
  selector: 'header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [IsInRolePipe]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() title: string;

  currentUrl = '';
  public isNavigateToLicensePage: boolean = false;
  public PDFAssignerRole: string = AppConstants.PDF_ASSIGNER_ROLE;
  public AdministratorRole: string = AppConstants.ADMINISTRATOR_ROLE;
  public CategoryManagerRole: string = AppConstants.CATEGORY_MANAGER_ROLE;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly router: Router,
    private readonly licenseService: LicenseService,
    private readonly isInRolePipe: IsInRolePipe,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.subscriptions.add(
      this.licenseService.licenseStatusModel$.subscribe((licenseStatusModel: LicenseStatusModel) => {
        this.isNavigateToLicensePage =
          licenseStatusModel &&
          !licenseStatusModel.IsLicensed &&
          licenseStatusModel.EvaluationDaysLeft <= 0 &&
          this.isInRolePipe.transform(this.AdministratorRole);
      })
    );
  }

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.isNavigateToLicensePage =
      this.licenseService.licenseStatusModel &&
      !this.licenseService.licenseStatusModel.IsLicensed &&
      this.licenseService.licenseStatusModel.EvaluationDaysLeft <= 0 &&
      this.isInRolePipe.transform(this.AdministratorRole);
  }

  isAllowedByLicense(): boolean {
    return this.licenseService.isAllowedByLicense(AppConstants.PDF_FILE_TYPE);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onLogout() {
    this.licenseService.removePasswordExpirationWarning();
    localStorage.removeItem(AppConstants.AUTH_DATA_NAME);
    this.router.navigate(['/Account']);
  }

  onAdminClick(): void {
    this.licenseService.isNavigateToAdmin = true;
  }

  onNavigateToHelpLink(): void {
    this.document.defaultView.open(AppConstants.DDS_HELP_PATH, '_blank')
  }
}
